// import { API, Auth } from "aws-amplify";

import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface iDrawerState {
  isDrawerOpen: boolean;
  drawerWidth: number;
  itemList: string[] | null;
  isCollapsed: boolean; // 추가
}

const drawerState: iDrawerState = {
  isDrawerOpen: true,
  drawerWidth: 240,
  itemList: null,
  isCollapsed: false, // 추가
};

export const drawerSlice = createSlice({
  name: "drawer",
  initialState: drawerState,
  reducers: {
    openDrawer: (state: any) => {
      state.isDrawerOpen = true;
    },
    closeDrawer: (state: any) => {
      state.isDrawerOpen = false;
    },
    deleteDrawerItem: (state: any, action: PayloadAction<string>) => {
      let newItemList = [];
      for (const itemName of state.itemList) {
        if (itemName !== action.payload) {
          newItemList.push(itemName);
        }
      }
      state.itemList = newItemList;
    },
    setDrawerWidth: (state, action) => {
      state.drawerWidth = action.payload;
    }
  },
});

export const { openDrawer, closeDrawer, deleteDrawerItem, setDrawerWidth } =
  drawerSlice.actions;

  export default drawerSlice.reducer;